import {useState} from 'react';
import moment from 'moment';
import omit from 'lodash/omit';
import {useSearchParams} from 'react-router-dom';
import {connect} from 'react-redux';

import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';

import useUser from '../../hooks/useUser';
import {parseErrorFromResponse} from '../../helpers/errors';
import {useCreateSessionMutation} from '../../redux/services/sessionApi';
import AppDashboard from '../AppDashboard';
import CustomBox from '../../components/common/CustomBox';
import ExistingPatientBookingForm from '../../components/booking/ExistingPatientBookingForm';
import ScheduleSpecificProviderForm from '../../components/booking/ScheduleSpecificProviderForm';
import AppointmentSuccessScreen from '../../components/scheduling/AppointmentSuccessScreen';

const handleSubmit = ({post, formData}) => async (e, {location_type, location_id}) => {
  console.log('handleSubmit', formData);
  let session = omit(formData, ['location_type', 'location_id']);
  if (location_type) session.location_type = location_type;
  if (location_id) session.location_id = location_id;
  const res = await post({body: session});
  return res;
};

const ExistingPatientBookingPage = props => {
  const user = useUser();
  const [search] = useSearchParams();
  const providerId = search.get('providerId');
  const searchMethod = search.get('searchMethod');
  // if (!searchMethod) return <PatientWaysToBook />;
  const [post, response] = useCreateSessionMutation();
  const onSubmit = handleSubmit({
    post,
    formData: props.formData,
  });
  console.log('RESPONSE', response);
  return (
    <AppDashboard
      title="Schedule a Session"
      loading={!user}
      hideBack={true}
      error={response?.error ? new Error(parseErrorFromResponse(response)) : null}
      showUser
    >
      <Stack pt={2}>
        {!!response?.isSuccess && 
          <AppointmentSuccessScreen
            appointment={
              response?.data?.appointment_scheduled
              ? {...response?.data?.appointment_scheduled, provider: response?.data?.provider}
              : null
            }
            patientId={user?.patient?.id}
            isProvider={false}
          />
        }
        {!response?.isSuccess && (
          !!providerId 
          ? <Container maxWidth='xs'>
              <CustomBox>
                <ScheduleSpecificProviderForm 
                  providerId={providerId}
                  onSubmit={onSubmit}
                />
              </CustomBox>
            </Container>
          : <ExistingPatientBookingForm 
            searchMethod={searchMethod} 
            afterSubmit={onSubmit}
          />
        )
        }
      </Stack>
    </AppDashboard>
  );
};

const mapState = state => ({
  formData: {
    provider_id: state.newAppointmentForm?.providerId,
    session_type_id: state.newAppointmentForm?.sessionTypeId,
    provider_availability_id: state.newAppointmentForm?.providerAvailabilityId,
    location_type: state.newAppointmentForm?.locationType,
    location_id: state.newAppointmentForm?.locationId,
    start_time: moment(
      `${state.newAppointmentForm?.date} ${state.newAppointmentForm?.time}`, 
      'MM/DD/yyyy hh:mm a'
    ).toISOString(),
    is_eval: false,
  },
});

const mapDispatch = dispatch => ({
});

export default connect(mapState, mapDispatch)(ExistingPatientBookingPage);